import { CreateLenderAvailability } from '@thro-types/leihbar';
import { Template } from '@thro-types/notification';

import { TFunction } from 'i18next';
import { z } from 'zod';

import { translations } from 'locales/i18n';

export const initialMailTemplateValues = (initialTemplate?: Template): Partial<Template> => {
  return initialTemplate
    ? initialTemplate
    : {
        name: '',
        html: '',
        subject: '',
        text: '',
        variables: {}
      };
};

export const initialOpeningHoursValues = (
  initialOpeningHours?: CreateLenderAvailability
): CreateLenderAvailability => {
  return initialOpeningHours ? initialOpeningHours : { availabilityTimes: [] };
};

export const lenderZodSchema = (t: TFunction<'translation', undefined>) =>
  z.object({
    availabilityTimes: z.array(
      z.object({
        weekdays: z.array(z.string()).min(1, t(translations.validation.oneWeekDayRequired())),
        start: z.number(),
        end: z.number()
      })
    )
  });
